<div class="modal-header">
  <h4 class="modal-title header-5">
    {{ configs.title }}
  </h4>
  <button
    type="button"
    class="accello-icon-btn"
    (mousedown)="isActive = true"
    (mouseup)="isActive = false"
    (mouseleave)="isActive = false"
    (click)="activeModal.dismiss('Cross click')"
  >
    <img
      [src]="
        isActive
          ? 'assets/images/virtusa-icons/close-dark.svg'
          : 'assets/images/virtusa-icons/close.svg'
      "
      alt="Close"
    />
  </button>
</div>

<div class="modal-body agent-modal">
  <div class="mb-3">
    <label class="form-label general-text-6">
      Mapping Name
      <span class="text-danger">*</span>
    </label>
    <input
      type="text"
      class="form-control"
      [formControl]="mappingNameControl"
      placeholder="Add mapping name"
    />
    <div
      *ngIf="mappingNameControl.invalid && mappingNameControl.touched"
      class="text-danger mt-1"
    >
      Mapping Name is required
    </div>
  </div>
  
  <div class="mb-3">
    <label class="form-label general-text-6">
      Upload Test Cases
      <span class="text-danger">*</span>
    </label>
    
    <div
      class="file-upload-area"
      [class.drag-over]="isDragOver"
      (drop)="onDrop($event)"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
    >
      <div class="upload-icon">
        <img src="assets/images/virtusa-icons/add-outline-gray.svg" alt="upload" />
      </div>
      <div class="upload-text">
        <label class="file-chooser">
           Add your test case file here (only.csv)
          <input
            type="file"
            accept=".csv"
            (change)="onFileSelected($event)"
            hidden
          />
        </label>
      </div>
      <div class="selected-file" *ngIf="selectedFile">
        <i class="ri-file-line"></i> {{ selectedFile.name }}
      </div>
    </div>
    <div
      *ngIf="testCasesFileControl.invalid && testCasesFileControl.touched"
      class="text-danger mt-1"
    >
      <span *ngIf="testCasesFileControl.hasError('required')"
        >Test Cases file is required</span
      >
      <span *ngIf="testCasesFileControl.hasError('invalidFileType')"
        >Only CSV files are allowed</span
      >
    </div>
  </div>

  <app-dynamic-form
    [form]="dynamicForm"
    [formFields]="fields"
  ></app-dynamic-form>
</div>

<div class="modal-footer">
  <div class="d-flex justify-content-end">
    <button
      class="btn-accello-secondary mx-2"
      (click)="activeModal.dismiss('Cross click')"
    >
      Cancel
    </button>
    <button
      class="btn-accello-primary-light"
      (click)="generate()"
      [disabled]="!isFormValid()"
    >
      {{ configs?.saveBtnText ? configs.saveBtnText : "Generate" }}
    </button>
  </div>
</div>
